/* eslint-disable */

import React from 'react';
import classNames from 'classnames/bind';
import styles from './Contract.module.scss';

const cx = classNames.bind(styles);

function Contract_01() {
	return (
		<div className={cx('terms')}>
			<p className={cx('font_bold')}>자동차매매계약 약관 (자동차등록규칙 별지 제16호 서식에 의거함)</p>
			<h3 className={cx('tit_terms')}>제1조(당사자표시)</h3>
			<p className={cx('cont_terms')}>양도인을 "갑"이라 하고, 양수인을 "을"이라 한다.</p>

			<h3 className={cx('tit_terms')}>제2조(동시이행 등)</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "갑"은 잔금 수령과 상환으로 소유권이전등록에 필요한 서류와 매매목적물을 "을"에게 인도하기로 한다. 다만, "갑"과 "을"의 합의에
					따라 매매금액의 2/3 이상의 상당액을 지급한 경우에는 매매목적물을 인도할 수 있다.
				</li>
				<li>
					② "을"은 "갑"에게 잔금을 지급함과 동시에 소유권이전등록의 절차에 필요한 서류와 등록비용을 자동차매매업자(이하 "매매업자"라
					한다)에게 내주어야 한다.{' '}
				</li>
				<li>③ 매매업자는 잔금지급일부터 15일 이내에 자동차소유권 이전등록 신청을 하여야 한다.</li>
			</ul>

			<h3 className={cx('tit_terms')}>제3조(공과금 부담)</h3>
			<p className={cx('cont_terms')}>
				이 자동차에 대한 제세공과금은 자동차 인도일을 기준으로 하여, 그 기준일까지의 분은 "갑"이 부담하고 기준일 다음날부터의 분은 "을"이
				부담한다. 다만, 관계법령에 제세공과금 납부에 관하여 특별한 규정이 있는 경우에는 그에 따른다.
			</p>

			<h3 className={cx('tit_terms')}>제4조(사고책임)</h3>
			<p className={cx('cont_terms')}>
				"을"은 이 자동차를 인수한 때부터 발생하는 모든 사고에 대하여 자기를 위하여 운행하는 자로서의 책임을 진다.
			</p>

			<h3 className={cx('tit_terms')}>제5조(법률상의 하자책임)</h3>
			<ul className={cx('cont_terms')}>
				<li>① 자동차 인도일 이전에 발생한 행정처분 또는 이전등록 요건의 불비 등의 하자에 대해서는 "갑"이 그 책임을 진다.</li>
				<li>
					② 매매업자는 「자동차관리법」 제58조제1항에 따라 자동차의 성능∙상태의 전검 내용을 "을"에게 알려야 하고, "을"이 원하는 경우 같은 법
					제58조의4에 해당하는 자가 자동차 가격을 조사∙산정한 내용을 알려야 한다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제6조(해약금 등)</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "갑"이 이 계약을 위반한 경우에는 "갑"은 해약금으로 계약금의 2배액을 "을"에게 배상해야 하며, "을"이 위약한 경우에는 "을"은
					"갑"에게 계약금의 반환을 요구할 수 없다. 다만, 손해배상의 청구는 방해하지 않는다,
				</li>
				<li>
					② 제5조제2항에 따라 "갑"이 고지한 자동차의 성능∙상태의 점검내용 중 주행거리, 사고 또는 침수사실이 다르거나, "갑"이 자동차의
					성능∙상태의 점검내용 또는 압류∙저당권의 등록 여부를 거짓으로 고지하거나 고지하지 아니한 경우 "을"은 자동차인도일로부터 30일 이내에
					매매계약을 해제할 수 있으며, 이 경우 "을"은 자동차를 즉시 "갑"에게 반환하고, "갑"은 자동차의 반환과 동시에 이미 지급받은
					매매금액을 "을"에게 반환하여야 한다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제7조(매매업자의 책임)</h3>
			<p className={cx('cont_terms')}>
				제5조의 하자에 대해서는 매매업자가 매도인과 동일한 책임을 지며, 시∙도의 조례가 하자보증금을 예치하도록 하는 경우 매수인의 요청이
				있을때에는 그 하자보증금으로 매수인에게 우선 지급해야 한다. 다만, 매매업자는 양도인 또는 그 하자에 책임이 있는 자에 대하여 구상권을
				행사할 수 있다.
			</p>

			<h3 className={cx('tit_terms')}>제8조(등록 지체 책임)</h3>
			<p className={cx('cont_terms')}>
				"갑"과 "을"이 매매업자에게 이전등록의 대행에 필요한 서류 등의 발급 또는 권한의 위임을 한 후 매매업자가 이전등록 신청을 대행하지
				않을때에는 이에 대한 모든 책임을 매매업자가 진다.
			</p>

			<h3 className={cx('tit_terms')}>제9조(할부승계 특약)</h3>
			<p className={cx('cont_terms')}>
				"갑"이 자동차를 할부로 구입하여 할부금을 다 내지 않는 상태에서 "을"에게 양도하는 경우에는 나머지 할부금을 "을"이 승계하여 부담할
				것인지의 여부를 특약사항란에 적어야 한다.
			</p>

			<h3 className={cx('tit_terms')}>제10조(계약서)</h3>
			<p className={cx('cont_terms')}>
				이 계약서는 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;년 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;월
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;일 4통 작성하여 "갑"이 1통, "을"이 1통, 등록절차를 대행하는 매매업자가 2통씩 각각
				지닌다.
			</p>

			<dl className={cx('dl_type3')}>
				<dt>유의사항</dt>
				<dd>1. 이 양도증명서는 「자동차관리법」에 따라 자동차매매업의 등록을 한 자만이 사용할 수 있습니다.</dd>
				<dd>2. 매매업자는 반드시 직인을 찍어야 합니다.</dd>
				<dd>3. 자동차매매사업조합의 중고자동차 제시 또는 매도신고번호를 적어야 합니다.</dd>
				<dd>
					4. 자동차정비, 검사, 주행거리 이력, 자동차세 납부여부와 압류내역 등 자동차토탈이력정보는 국토교통부에서 제공하는 스마트폰용
					어플("마이카정보") 또는 자동차민원대국민포털(www.ecar.go.kr)에서 조회가 가능하므로 확인 바랍니다.
				</dd>
			</dl>
		</div>
	);
}

export default Contract_01;
